import { TimeReportStatus } from '@app/shared/types/models/reports/time-report';

export enum TimeReportFilterName {
  Kind = 'kind',
  Status = 'status',
  Dates = 'dates',
  Users = 'users',
  Companies = 'companies',
  Tasks = 'tasks',
  Projects = 'projects',
  Locations = 'locations',
  Types = 'types'
}

export type TimeReportKindFilter = 'All' | 'WorkTime' | 'Absence';
export type TimeReportStatusFilter = 'All' | TimeReportStatus;
export enum SelectedTimeReportTypeEnum {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  RANGE = 'RANGE'
}

export enum TimeReportSessionTypeEnum {
  DURATION = 'DURATION',
  STANDARD = 'STANDARD',
  BANK_PLUS = 'BANK_PLUS',
  BANK_MINUS = 'BANK_MINUS',
  OVERTIME_50 = 'OVERTIME_50',
  OVERTIME_100 = 'OVERTIME_100'
}

export enum SortingDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum GroupingModeEnum {
  NONE = 'NONE',
  USER = 'USER',
  DATE = 'DATE',
  USER_DATE = 'USER_DATE',
  TASK = 'TASK',
  PROJECT = 'PROJECT',
  COMPANY = 'COMPANY',
  TYPE = 'TYPE'
}

export enum HumanizedColumnNames {
  DATE = 'Date',
  TASK_ID = 'Task ID',
  TASK_TITLE = 'Task Title',
  STATUS = 'Status',
  PROJECT = 'Project',
  USER = 'User',
  DESCRIPTION = 'Description',
  LOCATION = 'Location',
  TYPE = 'Type',
  TOTAL = 'Total',
  UNKNOWN = 'Unknown Column'
}

export enum ReportColumnsEnum {
  DATE = 'date',
  MONTH = 'month',
  WEEK = 'week',
  USER = 'createdBy.fullName',
  COMPANY = 'company',
  PROJECT = 'task.project.name',
  TASK_ID = 'task.taskNumber',
  TASK_LINK = 'taskLink',
  TASK_TITLE = 'task.name',
  LOCATION = 'location.locationsPath',
  DESCRIPTION = 'description',
  TYPE = 'hoursType',
  TOTAL = 'total',
  DECIMAL_HOURS = 'decimalHours',
  ESTIMATION = 'ESTIMATION',
  STATUS = 'status',
  STANDARD = 'standard',
  BANK_PLUS = 'bankPlus',
  BANK_MINUS = 'bankMinus',
  OVERTIME_50 = 'OVERTIME_50',
  OVERTIME_100 = 'OVERTIME_100'
}

export enum TableColumnsEnum {
  SELECT = 'select',
  DATE = 'date',
  USER = 'user',
  COMPANY = 'company',
  PROJECT = 'project',
  TASK_ID = 'taskId',
  TASK_TITLE = 'taskTitle',
  LOCATION = 'location',
  DESCRIPTION = 'description',
  TYPE = 'type',
  COMMENT = 'comment',
  ESTIMATION = 'estimation',
  TOTAL = 'total',
  STATUS = 'status',
  ACTIONS = 'actions'
}

export interface SelectedContext {
  year: number;
  month: number;
  week: number;
  day: number;
  labelHeader: string | number | undefined;
  label: string | number | undefined;
}

export interface TimeReportFilters {
  kind?: TimeReportKindFilter;
  status?: TimeReportStatusFilter;
  users?: string[];
  companies?: string[];
  projects?: string[];
  tasks?: string[];
  locations?: string[];
  dates?: string[];
  types?: string[];
}

export type DurationPipeType = 'intlDuration' | 'hmDuration';

export interface TimeReportFilterConfig {
  name: TimeReportFilterName;
  placeholder: string;
  items: { value: string; label: string }[];
  hideForAbsence: boolean;
  multiple: boolean;
}
